import axios, { AxiosInstance } from 'axios';

import store from 'app-redux';
import { showNotification } from 'app-redux/notification.saga';
import { nameof } from 'utils/typeHelpers';

import AuthApi from '../api/AuthApi';
import { getAccessToken } from '../auth/AuthorizeService';

const responseActionTypes = {
  post: `created`,
  put: `updated`,
  delete: `deleted`,
};

const errorActionTypes = {
  get: 'fetch',
  post: `create`,
  put: `update`,
  delete: `delete`,
};

export const requestInterceptor = async request => {
  // TODO: Queue all calls when token refresh in progress
  // Sets auth header for all outgoing requests
  request.headers.Authorization = `Bearer ${(await getAccessToken()) || ''}`;
  return request;
};

export const responseInterceptor = response => {
  const method = response?.config?.method;
  if (
    [
      nameof<typeof responseActionTypes>('post'),
      nameof<typeof responseActionTypes>('put'),
      nameof<typeof responseActionTypes>('delete'),
    ].includes(method)
  ) {
    const entityType = response.config.headers['X-Entity-Type'];
    if (entityType) {
      const actionType = responseActionTypes[response.config.method];
      store.dispatch(
        showNotification({
          type: 'SHOW_SUCCESS_NOTIFICATION',
          payload: `${entityType} ${actionType} successfully`,
        })
      );
    }
  }
  return response;
};

export const errorInterceptor = error => {
  if (error?.config && error?.response?.status === 401) {
    return AuthApi.logOut(true);
  }

  if (error?.response?.config) {
    const method = error.response.config.method || '';
    if (
      [
        nameof<typeof errorActionTypes>('get'),
        nameof<typeof errorActionTypes>('post'),
        nameof<typeof errorActionTypes>('put'),
        nameof<typeof errorActionTypes>('delete'),
      ].includes(method)
    ) {
      const entityType = error.response.config.headers['X-Entity-Type'];
      if (entityType) {
        const actionType = errorActionTypes[method];
        store.dispatch(
          showNotification({
            type: 'SHOW_ERROR_NOTIFICATION',
            payload: `Failed to ${actionType} ${entityType}`,
          })
        );
      }
    }
  } else if (!axios.isCancel(error)) {
    store.dispatch(
      showNotification({
        type: 'SHOW_ERROR_NOTIFICATION',
        payload: `Network error`,
      })
    );
  }
  return Promise.reject(error);
};

export function initInterceptors(axiosInstance: AxiosInstance) {
  axiosInstance.interceptors.response.use(responseInterceptor, errorInterceptor);
  axiosInstance.interceptors.request.use(requestInterceptor);
}
